













import { HighlightsButtonMeta } from '@front-app/modules/group/highlights/model';
import { defineComponent, PropType } from '@vue/composition-api';
import BaseButtonRender from './BaseButtonRender.vue';

export default defineComponent({
	components: {
		BaseButtonRender,
	},
	props: {
		meta: {
			type: Object as PropType<HighlightsButtonMeta>,
			required: true,
		},
	},
	setup() {
		return {};
	},
});
